import { useState, useEffect, useRef } from "react";
import { APP_VERSION } from "../version";

const CHECK_INTERVAL = 5 * 60 * 1000;

export default function useVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [newVersion, setNewVersion] = useState(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch(
          `${process.env.PUBLIC_URL}/version.json?t=${Date.now()}`,
          { cache: "no-store" }
        );
        if (!res.ok) return;

        const data = await res.json();
        if (data.version && data.version !== APP_VERSION) {
          setNewVersion(data.version);
          setUpdateAvailable(true);
        }
      } catch {
        // Silenciar errores de red; se reintenta en el próximo ciclo
      }
    };

    checkVersion();
    intervalRef.current = setInterval(checkVersion, CHECK_INTERVAL);

    return () => clearInterval(intervalRef.current);
  }, []);

  const reload = () => window.location.reload();

  return { updateAvailable, newVersion, currentVersion: APP_VERSION, reload };
}
